import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IMyProgressVm } from '../my-progress-vm.model';
import { IMyProgressUm } from '../my-progress-um.model';
@Injectable({ providedIn: 'root' })
export class MyProgressService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/MyProgress`;
  }
  get(): Observable<IMyProgressVm> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    return this.http.get<IMyProgressVm>(this.baseUrl, { headers, params });
  }
  put(myProgressUm: IMyProgressUm): Observable<IMyProgressUm> {
    const headers = this.createHeaders();
    return this.http.put<IMyProgressUm>(this.baseUrl, myProgressUm, { headers });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
